/**
 * Plantillas para partir, en vez de una hoja en blanco.
 *
 * La primera es la que originó la funcionalidad: el certificado de asistencia a
 * la capacitación de prevención de riesgos del 2026-10-23. Lo que cambia de una
 * charla a otra (nombre, relator, objetivo) son **campos del envío**, así una
 * sola plantilla sirve para todas.
 *
 * ⚠️ Texto en neutro: la ficha no registra el género y adivinarlo desde el
 * nombre deja un error impreso.
 */
import type { CampoDelEnvio } from '../../hooks/usePlantillasDocumentos'

export interface EjemploDePlantilla {
  id: string
  name: string
  description: string
  content_html: string
  envio_fields: CampoDelEnvio[]
}

export const EJEMPLOS: EjemploDePlantilla[] = [
  {
    id: 'certificado-asistencia',
    name: 'Certificado de asistencia a capacitación',
    description: 'Para firmar al terminar una charla o capacitación. El nombre, el relator y el objetivo se escriben en cada envío.',
    envio_fields: [
      { key: 'capacitacion', label: 'Capacitación', required: true, multiline: false },
      { key: 'relator', label: 'Relator', required: true, multiline: false },
      { key: 'objetivo', label: 'Objetivo', required: false, multiline: true },
    ],
    content_html: `
<table><tbody><tr>
  <td>{{empresa.logo}}</td>
  <td><h2 style="text-align: center">Certificado de asistencia</h2><p style="text-align: center"><strong>Prevención de riesgos</strong></p></td>
</tr></tbody></table>
<table><tbody>
  <tr><td><strong>Fecha</strong></td><td>{{fecha_de_hoy}}</td></tr>
  <tr><td><strong>Nombre</strong></td><td>{{trabajador.nombre_completo}}</td></tr>
  <tr><td><strong>RUT</strong></td><td>{{trabajador.rut}}</td></tr>
  <tr><td><strong>Capacitación</strong></td><td>{{envio.capacitacion}}</td></tr>
  <tr><td><strong>Relator</strong></td><td>{{envio.relator}}</td></tr>
</tbody></table>
<h3>Objetivo de la capacitación</h3>
<p>{{envio.objetivo}}</p>
<h3>Declaración de asistencia</h3>
<p style="text-align: justify">Por la presente, declaro haber asistido y participado activamente en la capacitación indicada, comprendiendo la importancia de la prevención de riesgos en el desarrollo de mis funciones laborales. Me comprometo a aplicar los conocimientos adquiridos para resguardar mi seguridad y la de mis compañeros y compañeras de trabajo.</p>
<p><strong>Empresa:</strong> {{empresa.razon_social}}<br><strong>RUT:</strong> {{empresa.rut}}<br><strong>Dirección:</strong> {{empresa.direccion}}</p>`.trim(),
  },
  {
    id: 'entrega-epp',
    name: 'Entrega de elementos de protección personal',
    description: 'Constancia de que la persona recibió sus elementos de protección. Los elementos entregados se escriben en cada envío.',
    envio_fields: [
      { key: 'elementos', label: 'Elementos entregados', required: true, multiline: true },
    ],
    content_html: `
<h2 style="text-align: center">Comprobante de entrega de elementos de protección personal</h2>
<p>En {{empresa.comuna}}, a {{fecha_de_hoy_larga}}, {{empresa.razon_social}}, RUT {{empresa.rut}}, entrega a {{trabajador.nombre_completo}}, RUT {{trabajador.rut}}, cargo {{trabajador.cargo}}, los siguientes elementos de protección personal:</p>
<p>{{envio.elementos}}</p>
<p style="text-align: justify">Declaro haberlos recibido en buen estado y me comprometo a usarlos durante mi jornada, a cuidarlos y a solicitar su reposición cuando corresponda.</p>`.trim(),
  },
]
